<template>
  <div
    class="mt-3">
    <v-layout wrap>
      <v-flex>
        <v-snackbar
          v-model="dialog.snackbar"
          top
          right
          color="green">
          <span 
            class="body-1 font-weight-light white--text"
            v-html="message.success">
          </span>

          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              color="white"
              class="body-1 font-weight-bold text-capitalize"
              v-bind="attrs"
              @click="dialog.snackbar = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </template>
        </v-snackbar>

        <v-dialog v-model="dialog.freeze"
          @keydown.esc="dialog.freeze = false"
          :fullscreen="dialog.fullscreen"
          width="400"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pt-3 pb-0 text-right popup-header">
              Freeze Kolom

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                color="#718EBF">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mt-3 mb-2"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-text 
              class="py-0">
              <v-form>
                <v-row>
                  <v-col>
                    <div>
                      <div 
                        class="mb-2">
                        Silahkan pilih kolom yang akan di <b class="font-italic">"Freeze"</b>
                      </div>

                      <v-list-item-group
                        multiple>
                        <v-list flat>
                          <v-list-item 
                            v-for="(item, index) in configHeaders" 
                            :key="index"
                            class="px-0"
                            @click="item.freeze = !item.freeze ? true : false">
                            <v-list-item-action 
                              class="mr-4">
                              <v-checkbox
                                color="#718EBF"
                                :input-value="item.freeze">
                              </v-checkbox>
                            </v-list-item-action>

                            <v-list-item-content>
                              <div
                                :class="item.freeze ? 'font-weight-bold' : ''"
                                :style="item.freeze ? `color: ${set_color};` : ''">
                                {{ item.text }}
                              </div>
                            </v-list-item-content>
                          </v-list-item>  
                        </v-list>
                      </v-list-item-group>
                    </div>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>

            <v-divider 
              class="mb-3 mt-0"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-actions
              class="mb-2">
              <v-spacer/>

              <v-btn
                elevation="0"
                color="#718EBF"
                style="border-radius: 10px;"
                class="body-2 font-weight-bold text-capitalize white--text"
                @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();">
                <v-icon small class="mr-1">mdi-check-bold</v-icon>
                Freeze
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.hide"
          @keydown.esc="dialog.hide = false"
          :fullscreen="dialog.fullscreen"
          width="400"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pt-3 pb-0 text-right popup-header">
              Hide Kolom

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                color="#718EBF">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.hide = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mt-3 mb-2"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-text 
              class="py-0">
              <v-form>
                <v-row>
                  <v-col>
                    <div>
                      <div class="mb-2">
                        Silahkan pilih kolom yang akan di <b class="font-italic">"Hide"</b>
                      </div>

                      <v-list-item-group
                        multiple>
                        <v-list flat>
                          <v-list-item 
                            v-for="(item, index) in headers" 
                            :key="index"
                            class="px-0"
                            @click="item.hide = !item.hide ? true : false">
                            <v-list-item-action 
                              class="mr-4">
                              <v-checkbox
                                color="#718EBF"
                                :input-value="item.hide">
                              </v-checkbox>
                            </v-list-item-action>

                            <v-list-item-content>
                              <div
                                :class="item.hide ? 'font-weight-bold' : ''"
                                :style="item.hide ? `color: ${set_color};` : ''">
                                {{ item.text }}
                              </div>
                            </v-list-item-content>
                          </v-list-item>  
                        </v-list>
                      </v-list-item-group>
                    </div>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>

            <v-divider 
              class="mb-3 mt-0"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-actions
              class="mb-2">
              <v-spacer/>

              <v-btn
                elevation="0"
                color="#718EBF"
                style="border-radius: 10px;"
                class="body-2 font-weight-bold text-capitalize white--text"
                @click="dialog.hide = false; dialog.fullscreen = false; addHides();">
                <v-icon small class="mr-1">mdi-check-bold</v-icon>
                Hide
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.filter"
          @keydown.esc="dialog.filter = false"
          :fullscreen="dialog.fullscreen"
          width="400"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              <div
                class="title font-weight-bold">
                Filter Data
              </div>

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                color="#718EBF">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.filter = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="py-0 my-4">
              <v-select
                filled
                rounded
                dense

                color="#718EBF"
                placeholder="Contoh. 2023"

                hide-details

                :items="years"
                :item-color="set_color"

                v-model="filter.year"
                style="border-radius: 10px;">
              </v-select>
            </v-card-text>
            
            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn 
                @click="dialog.filter = false; fetch();"
                width="120"
                elevation="0"
                color="green"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Filter
              </v-btn>

              <v-btn 
                @click="dialog.filter = false"
                width="120"
                outlined
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.form"
          @keydown.esc="dialog.form = false"
          :fullscreen="dialog.fullscreen"
          width="600"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <div 
              class="d-flex align-start pa-4 popup-header">
              <div
                class="fs-17 font-weight-bold" style="width: 450px;">
                {{ form.id === '' ? 'Tambah' : 'Ubah' }} Project
              </div>

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.form = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </div>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="py-0 my-4">
              <ValidationObserver 
                ref="form">
                <v-form>

                  <ValidationProvider
                    name="Nama Project" 
                    rules="required" 
                    v-slot="{ errors, valid }">
                    <div class="mb-2 font_weight_600 fs-13 black_one">
                      <span class="red--text">*</span>
                      Nama Project
                    </div>

                    <v-text-field
                      v-on:keydown.enter.prevent="save()"
                      
                      filled
                      rounded
                      dense

                      :color="set_color"
                      placeholder="Nama Project"

                      hide-details
                      autofocus

                      v-model="form.name"
                      :success="form.name !== '' && valid"
                      :error-messages="errors"
                      required
                      class="mb-6"
                      style="border-radius: 10px;">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="form.name !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>
                  <ValidationProvider
                    name="Nama Client" 
                    rules="required" 
                    v-slot="{ errors, valid }">
                    <div class="mb-2 font_weight_600 fs-13 black_one">
                      <span class="red--text">*</span>
                      Nama Client
                    </div>

                    <v-text-field
                      v-on:keydown.enter.prevent="save()"
                      
                      filled
                      rounded
                      dense

                      :color="set_color"
                      placeholder="Nama Client"

                      hide-details

                      v-model="form.client"
                      :success="form.client !== '' && valid"
                      :error-messages="errors"
                      required
                      class="mb-6"
                      style="border-radius: 10px;">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="form.client !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>
                  <ValidationProvider
                    name="Nama Leader" 
                    rules="required" 
                    v-slot="{ errors, valid }">
                    <div class="mb-2 font_weight_600 fs-13 black_one">
                      <span class="red--text">*</span>
                      Nama Leader
                    </div>

                    <v-autocomplete
                      v-on:keydown.enter.prevent="save()"
                      
                      filled
                      rounded
                      dense

                      :color="set_color"
                      placeholder="Nama Leader"

                      hide-details
                      :items="user_data"
                      :item-color="set_color"
                      item-text="name"
                      item-value="name"

                      v-model="form.leader"
                      :success="form.leader !== '' && valid"
                      :error-messages="errors"
                      required
                      class="mb-6"
                      style="border-radius: 10px;">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="form.leader !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-autocomplete>
                  </ValidationProvider>

                  <ValidationProvider
                    name="Use" 
                    rules="required" 
                    v-slot="{ errors, valid }">
                    <div class="mb-2 font_weight_600 fs-13 black_one">
                      <span class="red--text">*</span>
                      Use
                    </div>

                    <v-autocomplete
                      v-on:keydown.enter.prevent="save()"
                      
                      filled
                      rounded
                      dense

                      :color="set_color"
                      placeholder="Use"

                      hide-details

                      :items="[{
                        text: 'Internal',
                        value: 'internal'
                      }, {
                        text: 'External',
                        value: 'external'
                      }]"  
                      :item-color="set_color"
                      item-text="text"
                      item-value="value"

                      v-model="form.use"
                      :success="form.use !== '' && valid"
                      :error-messages="errors"
                      required
                      style="border-radius: 10px;">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="form.use !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-autocomplete>
                  </ValidationProvider>
                  
                </v-form>
              </ValidationObserver>

              <div v-if="message.error.length > 0"
                class="text-center mt-6">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
            </v-card-text>
            
            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                @click="save()"
                :loading="process.form"
                :disabled="process.form"
                width="120"
                elevation="0"
                color="green"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Simpan
              </v-btn>

              <v-btn
                @click="dialog.form = false; reset();"
                :disabled="process.form"
                width="120"
                outlined
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>


        <v-dialog v-model="dialog.delete"
          @keydown.esc="dialog.delete = false"
          :fullscreen="dialog.fullscreen"
          width="500"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              Hapus Data

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.delete = false; dialog.fullscreen = false; reset();"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="body-1 font-weight-light text-first line-text-second mt-4">
              Apakah Anda yakin menghapus data <b class="font-weight-bold black--text">{{ dialog.plafon ? 'plafon' : 'project' }}</b> yang Anda pilih?
            </v-card-text>

            <div v-if="message.error.length > 0"
              class="text-center mx-6 my-4">
              <div
                class="error--text d-flex align-start">
                <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                
                <span
                  class="ml-1">
                  {{ message.error }}
                </span>
              </div>
            </div>

            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                rounded
                width="120"
                @click="deletes()"
                :loading="process.delete"
                :disabled="process.delete"
                color="green"
                elevation="0"
                class="body-2 font-weight-bold text-capitalize white--text">
                Ya, Hapus
              </v-btn>

              <v-btn
                rounded
                width="120"
                @click="dialog.delete = false; dialog.fullscreen = false; reset();"
                :disabled="process.delete"
                outlined
                class="body-2 font-weight-bold text-capitalize red--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.form_plafon"
          @keydown.esc="dialog.form_plafon = false"
          :fullscreen="dialog.fullscreen"
          width="600"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <div 
              class="d-flex align-start pa-4 popup-header">
              <div
                class="fs-17 font-weight-bold" style="width: 450px;">
                {{ form.id === '' ? 'Tambah' : 'Ubah' }} Rencana <b class="font-weight-bold black--text pl-0" v-if="selected.rencana.length > 0">{{ selected.rencana[0].title }}</b> di Project <b class="font-weight-bold black--text pl-1" v-if="selected.list.length > 0">{{ selected.list[0].name }}</b>
              </div>

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.form_plafon = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </div>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="py-0 my-4">
              <ValidationObserver 
                ref="form_plafon">
                <v-form>

                  <!-- <ValidationProvider
                    name="Nama" 
                    rules="required" 
                    v-slot="{ errors, valid }">
                    <div class="mb-2 font_weight_600 fs-13 black_one">
                      <span class="red--text">*</span>
                      Nama
                    </div>

                    <v-text-field
                      v-on:keydown.enter.prevent="save_plafon()"
                      
                      filled
                      rounded
                      dense

                      :color="set_color"
                      placeholder="Nama"

                      hide-details
                      autofocus

                      v-model="form_plafon.title"
                      :success="form_plafon.title !== '' && valid"
                      :error-messages="errors"
                      required
                      class="mb-6"
                      style="border-radius: 10px;">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="form_plafon.title !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider> -->
                  <ValidationProvider
                    name="Nominal" 
                    rules="required|min:0" 
                    v-slot="{ errors, valid }">
                    <div class="mb-2 font_weight_600 fs-13 black_one">
                      <span class="red--text">*</span>
                      Nominal
                    </div>
                    <v-currency-field
                      v-on:keydown.enter.prevent="save_plafon()"
                      
                      filled
                      rounded
                      dense

                      :color="set_color"
                      placeholder="Nominal"

                      hide-details

                      v-model="form_plafon.value"
                      :success="form_plafon.value !== '' && valid"
                      :error-messages="errors"
                      required
                      class="mb-6"
                      style="border-radius: 10px;">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="form_plafon.value !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-currency-field>

                  </ValidationProvider>

                  <ValidationProvider
                    name="Keterangan" 
                    rules="required" 
                    v-slot="{ errors, valid }">
                    <div class="mb-2 font_weight_600 fs-13 black_one">
                      <span class="red--text">*</span>
                      Keterangan
                    </div>

                    <v-textarea
                      v-on:keydown.enter.prevent="save_plafon()"
                      
                      filled
                      rounded
                      dense

                      :color="set_color"
                      placeholder="Keterangan"

                      hide-details

                      v-model="form_plafon.note"
                      :success="form_plafon.note !== '' && valid"
                      :error-messages="errors"
                      required
                      class="mb-6"
                      style="border-radius: 10px;">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="form_plafon.note !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-textarea>
                  </ValidationProvider>
                  
                </v-form>
              </ValidationObserver>

              </v-card-text>
              
              <v-divider 
                class="mt-2"
                style="border-top: 2px dashed #e0e0e0;"/>
              
              <v-card-actions
                class="pa-4">
                <div v-if="message.error.length > 0"
                  class="text-left mt-6">
                  <div
                    class="error--text d-flex align-start">
                    <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                    
                    <span
                      class="ml-1">
                      {{ message.error }}
                    </span>
                  </div>
                </div>
              <v-spacer/>

              <v-btn
                @click="save_plafon()"
                :loading="process.form"
                :disabled="process.form"
                width="120"
                elevation="0"
                color="green"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Simpan
              </v-btn>

              <v-btn
                @click="dialog.form_plafon = false; reset();"
                :disabled="process.form"
                width="120"
                outlined
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.plafon"
          @keydown.esc="dialog.plafon = false"
          :fullscreen="dialog.fullscreen"
          width="800"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              Data<b class="font-weight-bold black--text px-2" v-if="selected.rencana.length > 0">{{ selected.rencana[0].title }}</b> di Rencana Project <b class="font-weight-bold black--text pl-2" v-if="selected.list.length > 0">{{ selected.list[0].name }}</b>

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.plafon = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="body-1 font-weight-light text-first line-text-second mt-0">
              <div class="view">
                <v-row
                  class="py-0">
                  <v-col
                    cols="12"
                    md="12"
                    class="d-flex align-center">
                    <v-btn
                      color="#4B4B4B"
                      elevation="0"
                      small
                      v-if="hak_akses.action.add_report_rencana"
                      min-height="30"
                      @click="dialog.form_plafon = true; reset_plafon();"
                      class="fs-12 white--text text-capitalize d-flex align-center"
                      style="border-radius: 6px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                      <v-icon size="15">mdi-plus-circle-multiple</v-icon>
                      
                      <span
                        class="ml-2 ">
                        Tambah
                      </span>
                    </v-btn>
                    <!-- <v-btn
                      color="#4B4B4B"
                      elevation="0"
                      :disabled="process.load"
                      @click="dialog.form = true; reset();"
                      class="body-2 white--text text-capitalize d-flex align-center ml-0"
                      style="border-radius: 10px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                      <v-icon size="20">mdi-plus-circle-multiple</v-icon>
                      
                      <span
                        class="ml-2">
                        Tambah
                      </span>
                    </v-btn> -->
                    <!-- <v-text-field
                      @click:clear="search_plafon = ''; fetchDetail(selected.list[0].id);"
                      v-on:keyup.enter="fetchDetail(selected.list[0].id)"
      
                      filled
                      rounded
                      dense
                      single-line
      
                      hide-details
                      :color="set_color"
                      placeholder="Cari data yang Anda butuhkan . . ."
                      append-icon="mdi-magnify"
                      clearable
      
                      v-model="search_plafon"
                      min-height="30"
                      class="ml-3 fs-12 little-placeholder"
                      style="border-radius: 6px; background: #d9e8ff9c !important; max-width: 320px">
                    </v-text-field> -->
      
                    <!-- FREEZE COLUMN -->
                    <!-- <div class="ml-3">
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            elevation="0"
                            outlined
                            dark
                            min-width="36"
                            color="#7B7B7B"
                            class="text-capitalize px-0"
                            style="border-radius: 10px;"
                            v-bind="attrs"
                            v-on="on"
                            @click="dialog.freeze = true">
                            <v-icon size="18">mdi-table-split-cell</v-icon>
                          </v-btn>
                        </template>
      
                        <span>
                          Freeze
                        </span>
                      </v-tooltip>
                    </div> -->
      
                    <!-- HIDE COLUMN -->
                    <!-- <div class="ml-3">
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            elevation="0"
                            outlined
                            dark
                            min-width="36"
                            color="#7B7B7B"
                            class="text-capitalize px-0"
                            style="border-radius: 10px;"
                            v-bind="attrs"
                            v-on="on"
                            @click="dialog.hide = true">
                            <v-icon size="18">mdi-eye-off-outline</v-icon>
                          </v-btn>
                        </template>
      
                        <span>
                          Hide
                        </span>
                      </v-tooltip>
                    </div> -->
                  </v-col>
                </v-row>
                <div v-if="!process.detail" :class="process.detail || list_plafon.length === 0 ? '' : 'wrapper-project'">
                  <table style="border-radius: 10px; width: 100%;" class="table">
                    <tr>
                      <th v-if="hak_akses.action.delete_report_rencana" :style="`background-color: ${set_color}; color: #fff;`" class="sticky-col one-col" style="z-index: 1; background: #080679; color: white; font-size: 12px; border: 1px solid #ededed; border-left: 1px solid #ededed; width: 60px; min-width: 60px; max-width: 60px; padding: 8px 12px; text-align: center;">Aksi</th>
                      <th :style="`background-color: ${set_color}; color: #fff;`" style="background: #080679; color: white; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                        Nama Kategori
                        <span v-if="sortBy === 'title'">
                          <v-icon color="white" v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                          <v-icon color="white" v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                        </span>
                      </th>
                      <th :style="`background-color: ${set_color}; color: #fff;`" style="background: #080679; color: white; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                        Nominal
                        <span v-if="sortBy === 'client'">
                          <v-icon color="white" v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                          <v-icon color="white" v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                        </span>
                      </th>
                      <th :style="`background-color: ${set_color}; color: #fff;`" style="color: white; font-size: 12px !important; z-index: 1; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">Keterangan</th>
                      <!-- <th style="font-size: 14px !important; z-index: 1; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: right;">Selisih</th> -->
                    </tr>
                    <tr v-for="(item, index) in list_plafon" :key="index" @click="selected.row = index" :class="selected.row === index ? 'selected' : ''">
                      <td v-if="hak_akses.action.delete_report_rencana" class="sticky-col one-col" style="background: #fff; font-size: 12px; border: 1px solid #ededed; border-left: 1px solid #ededed; width: 60px; min-width: 60px; max-width: 100px; padding: 8px 12px; text-align: center;">
                        <!-- <v-tooltip 
                          top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              @click="reset_plafon(index); dialog.form_plafon = true;"
                              
                              v-bind="attrs"
                              v-on="on"

                              min-width="28"
                              small
                              rounded
                              color="blue"
                              elevation="0"
                              class="white--text text-capitalize mx-1 px-0"
                              style="font-weight: 600; border-radius: 6px;">
                              <v-icon small>mdi-square-edit-outline</v-icon>
                            </v-btn>
                          </template>

                          <span>Ubah</span>
                        </v-tooltip> -->
                        <v-tooltip 
                          top
                          v-if="hak_akses.action.delete_report_rencana">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              @click="toDelete(item.id)"

                              v-bind="attrs"
                              v-on="on"

                              min-width="28"
                              small
                              rounded
                              color="red"
                              elevation="0"
                              class="white--text text-capitalize mx-1 px-0"
                              style="font-weight: 600; border-radius: 6px;">
                              <v-icon small>mdi-trash-can-outline</v-icon>
                            </v-btn>
                          </template>
                          
                          <span>Hapus</span>
                        </v-tooltip>
                      </td>
                      <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; min-width: 250px; white-space: nowrap; text-align: left;">{{ item.category_title }}</td>
                      <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; min-width: 250px; white-space: nowrap; text-align: left;">{{ item.value | price }}</td>
                      <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; min-width: 250px; white-space: nowrap; text-align: left;">{{ item.note }}</td>
                      <!-- <td :style="((item.nominal*1) + (item.nominal_sp2b*1)) === (item.realisasi*1) ? '' : 'background: #FFCDD2;'" style="font-size: 12px; border: 1px solid #ededed; border-left: none; min-width: 150; max-width: 150px; padding: 8px 12px; text-align: left;">{{ (item.realisasi*1) | price }}</td> -->
                      <!-- <td :style="((item.nominal*1) + (item.nominal_sp2b*1)) === (item.realisasi*1) ? '' : 'background: #FFCDD2;'" style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 150px; min-width: 150; max-width: 150px; padding: 8px 12px; text-align: left;">
                        {{ ((item.nominal*1) + (item.nominal_sp2b*1)) === (item.realisasi*1) ? '' :((item.nominal*1) + (item.nominal_sp2b*1)) > (item.realisasi*1) ? '-' : '+'}}
                        {{ (((item.nominal*1) + (item.nominal_sp2b*1)) - (item.realisasi*1)) | price }}
                      </td> -->
                    </tr>
                  </table>
                </div>
  
                <v-card-text
                  v-if="process.detail" 
                  class="pb-0 my-4" 
                  style="height: 600px; display: flex; align-items: center; justify-content: center;">
                  <div class="text-center">
                    <div class="mb-4 title">
                      Mohon Tunggu . . .
                    </div>
  
                    <v-progress-linear
                      :color="set_color"
                      indeterminate
                      rounded
                      height="10">
                    </v-progress-linear>
                  </div>
                </v-card-text>
  
                <v-card-text
                  v-if="!process.detail && list_plafon.length === 0"
                  class="pb-0 my-4" style="height: 600px; display: flex; align-items: center; justify-content: center;">
                  <div class="text-center">
                    <v-img 
                      class="mx-auto"
                      contain
                      alt="vuetify"
                      :width="90"
                      :height="90"
                      :src="require('@/assets/image/empty.png')">
                      <!-- <template v-slot:placeholder>
                        <v-row
                          class=" "
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            indeterminate 
                            :color="set_color">
                          </v-progress-circular>
                        </v-row>
                      </template> -->
                    </v-img>
                    <div class="mt-3 fs-16">
                      Belum Ada Data
                    </div>
                  </div>
                </v-card-text>
              </div>
            </v-card-text>

            <!-- <div v-if="message.error.length > 0"
              class="text-center mx-6 my-4">
              <div
                class="error--text d-flex align-start">
                <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                
                <span
                  class="ml-1">
                  {{ message.error }}
                </span>
              </div>
            </div> -->

            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                rounded
                width="120"
                @click="dialog.plafon = false; dialog.fullscreen = false;"
                :disabled="process.delete"
                outlined
                class="body-2 font-weight-bold text-capitalize red--text">
                Tutup
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.ledger"
          @keydown.esc="closeLedgerDialog"
          :fullscreen="dialog.fullscreen"
          :content-class="ledgerDialogClass"
          width="95vw"
          persistent
          scrollable>
          <v-card 
            :class="[dialog.fullscreen ? 'non-border-radius' : 'border-radius', 'ledger-dialog']">
            <v-card-title class="d-flex align-center ledger-dialog__header">
              <div class="ledger-dialog__header-text text-truncate">
                {{ ledger_view === 'list' ? 'Data Realisasi' : 'Data Jurnal' }}
              </div>

              <v-spacer/>

              <div class="d-flex align-center ledger-dialog__header-actions">
                <v-btn
                  icon
                  x-small
                  elevation="0"
                  class="ledger-dialog__icon-btn"
                  :aria-label="dialog.fullscreen ? 'Keluar layar penuh' : 'Layar penuh'"
                  @click="dialog.fullscreen = !dialog.fullscreen ? true : false">
                  <v-icon size="18">{{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}</v-icon>
                </v-btn>
                <v-btn
                  icon
                  x-small
                  elevation="0"
                  class="ledger-dialog__icon-btn"
                  aria-label="Tutup dialog"
                  @click="closeLedgerDialog">
                  <v-icon size="18">mdi-close</v-icon>
                </v-btn>
              </div>
            </v-card-title>

            <v-card-text 
              class="body-1 font-weight-light text-first line-text-second mt-0 px-4 pb-2 ledger-dialog__body">
              <!-- LIST VIEW -->
              <div v-if="ledger_view === 'list'" class="view">
                <v-card-text
                  v-if="process.ledger" 
                  class="pb-0 my-4 ledger-dialog__loading">
                  <div class="text-center">
                    <div class="mb-4 title">Mohon Tunggu . . .</div>
                    <v-progress-linear color="#0072B2" indeterminate rounded height="10"></v-progress-linear>
                  </div>
                </v-card-text>

                <div v-if="!process.ledger" class="my-3">
                  <ProjectRealisasiTable
                    v-if="list_ledger.length > 0"
                    :items="list_ledger"
                    :category-title="selected.realisasi.length > 0 ? selected.realisasi[0].title : ''"
                    :project-name="selected.list.length > 0 ? selected.list[0].name : ''"
                    :balance="selected.realisasi.length > 0 ? selected.realisasi[0].balance : 0"
                    :pagination="ledger_pagination"
                    :pagination-display="ledger_paginationList"
                    :show-export="hak_akses.action.export"
                    :export-loading="process.export_ledger"
                    @row-click="toJurnalDetail"
                    @change-page="fetchLedger($event)"
                    @reload-page="fetchLedger($event)"
                    @export="exportLedgerExcel" />

                  <v-card-text
                    v-if="list_ledger.length === 0"
                    class="pb-0 my-4 ledger-dialog__empty">
                    <div class="text-center">
                      <v-img class="mx-auto" contain :width="90" :height="90" :src="require('@/assets/image/empty.png')"></v-img>
                      <div class="mt-3 fs-16">Belum Ada Data</div>
                    </div>
                  </v-card-text>

                </div>
              </div>

              <!-- JURNAL VIEW -->
              <div v-if="ledger_view === 'jurnal'" class="view mt-3">
                <v-card-text
                  v-if="process.jurnal" 
                  class="pb-0 my-4 ledger-dialog__loading">
                  <div class="text-center">
                    <div class="mb-4 title">Mohon Tunggu . . .</div>
                    <v-progress-linear color="#0072B2" indeterminate rounded height="10"></v-progress-linear>
                  </div>
                </v-card-text>

                <ProjectJurnalTable
                  v-if="!process.jurnal && list_jurnal.length > 0"
                  :groups="list_jurnal" />

                <v-card-text
                  v-if="!process.jurnal && list_jurnal.length === 0"
                  class="pb-0 my-4 ledger-dialog__empty">
                  <div class="text-center">
                    <v-img class="mx-auto" contain :width="90" :height="90" :src="require('@/assets/image/empty.png')"></v-img>
                    <div class="mt-3 fs-16">Belum Ada Data</div>
                  </div>
                </v-card-text>
              </div>
            </v-card-text>

            <div class="ledger-dialog__footer">
              <v-spacer/>
              <div class="d-flex align-center ledger-dialog__btn-group">
                <v-btn
                  v-if="ledger_view === 'jurnal'"
                  elevation="0"
                  small
                  min-height="30"
                  class="ledger-dialog__btn ledger-dialog__btn--back"
                  @click="backToLedgerList">
                  <v-icon size="16" class="ledger-dialog__btn-icon">mdi-arrow-left</v-icon>
                  <span>Kembali</span>
                </v-btn>
                <v-btn
                  elevation="0"
                  small
                  min-height="30"
                  class="ledger-dialog__btn ledger-dialog__btn--close"
                  @click="closeLedgerDialog">
                  Tutup
                </v-btn>
              </div>
            </div>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.form_rencana"
          @keydown.esc="dialog.form_rencana = false"
          :fullscreen="dialog.fullscreen"
          v-if="dialog.form_rencana"
          width="600"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <div 
              class="d-flex align-start pa-4 popup-header">
              <div
                class="fs-17 font-weight-bold" style="width: 450px;">
                {{ form.id === '' ? 'Tambah' : 'Ubah' }} Rencana
              </div>

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.form_rencana = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </div>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="py-0 my-4">
              <ValidationObserver 
                ref="form_rencana">
                <v-form>

                  <ValidationProvider
                    name="Nama" 
                    rules="required" 
                    v-slot="{ errors, valid }">
                    <div class="mb-2 font_weight_600 fs-13 black_one">
                      <span class="red--text">*</span>
                      Nama
                    </div>

                    <v-text-field
                      v-on:keydown.enter.prevent="save_rencana()"
                      
                      filled
                      rounded
                      dense

                      :color="set_color"
                      placeholder="Nama"

                      hide-details
                      autofocus

                      v-model="form_rencana.title"
                      :success="form_rencana.title !== '' && valid"
                      :error-messages="errors"
                      required
                      class="mb-6"
                      style="border-radius: 10px;">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="form_rencana.title !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>
                  
                </v-form>
              </ValidationObserver>

              </v-card-text>
              
              <v-divider 
                class="mt-2"
                style="border-top: 2px dashed #e0e0e0;"/>
              
              <v-card-actions
                class="pa-4">
                <div v-if="message.error.length > 0"
                  class="text-left mt-6">
                  <div
                    class="error--text d-flex align-start">
                    <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                    
                    <span
                      class="ml-1">
                      {{ message.error }}
                    </span>
                  </div>
                </div>
              <v-spacer/>

              <v-btn
                @click="save_rencana()"
                :loading="process.form"
                :disabled="process.form"
                width="120"
                elevation="0"
                color="green"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Simpan
              </v-btn>

              <v-btn
                @click="dialog.form_rencana = false; reset_rencana();"
                :disabled="process.form"
                width="120"
                outlined
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.delete_rencana"
          @keydown.esc="dialog.delete_rencana = false"
          :fullscreen="dialog.fullscreen"
          width="500"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              Hapus Data

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.delete_rencana = false; dialog.fullscreen = false; reset();"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="body-1 font-weight-light text-first line-text-second mt-4">
              Apakah Anda yakin menghapus data <b class="font-weight-bold black--text">Rencana</b> yang Anda pilih?
            </v-card-text>

            <div v-if="message.error.length > 0"
              class="text-center mx-6 my-4">
              <div
                class="error--text d-flex align-start">
                <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                
                <span
                  class="ml-1">
                  {{ message.error }}
                </span>
              </div>
            </div>

            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                rounded
                width="120"
                @click="deletesRencana()"
                :loading="process.delete"
                :disabled="process.delete"
                color="green"
                elevation="0"
                class="body-2 font-weight-bold text-capitalize white--text">
                Ya, Hapus
              </v-btn>

              <v-btn
                rounded
                width="120"
                @click="dialog.delete_rencana = false; dialog.fullscreen = false; reset_rencana();"
                :disabled="process.delete"
                outlined
                class="body-2 font-weight-bold text-capitalize red--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <section>
          <v-card 
            flat
            class="ma-4 mt-0 box-shadow pb-5"
            style="border-radius: 10px;">
            <v-card
            flat
            color="transparent">
            <v-card-text class="pt-1 pb-0">
              <div
                class="d-flex align-center">
                <div
                  class="d-flex align-center">
                  <v-avatar
                    tile
                    size="22">
                    <v-img
                      contain
                      alt="kominfoklaten"  
                      :src="require('@/assets/image/grip_menu.png')">
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height"
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            size="20"
                            indeterminate 
                            :color="set_color">
                          </v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </v-avatar>
  
                  <span
                    class="fs-16 black--text ml-2"
                    style="font-weight: 600;">
                    Project
                  </span>
                </div>
  
                <v-spacer />
  
              </div>
            </v-card-text>
          </v-card>
  
            <v-row
              class="pa-4 py-0">
              <v-col
                cols="12"
                md="12"
                class="d-flex align-center">
                <v-btn
                  color="#4B4B4B"
                  elevation="0"
                  small
                  v-if="hak_akses.action.add"
                  min-height="30"
                  @click="dialog.form = true; reset();"
                  class="fs-12 white--text text-capitalize d-flex align-center"
                  style="border-radius: 6px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                  <v-icon size="15">mdi-plus-circle-multiple</v-icon>
                  
                  <span
                    class="ml-2 ">
                    Tambah
                  </span>
                </v-btn>
                <!-- <v-btn
                  color="#4B4B4B"
                  elevation="0"
                  :disabled="process.load"
                  @click="dialog.form = true; reset();"
                  class="body-2 white--text text-capitalize d-flex align-center ml-0"
                  style="border-radius: 10px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                  <v-icon size="20">mdi-plus-circle-multiple</v-icon>
                  
                  <span
                    class="ml-2">
                    Tambah
                  </span>
                </v-btn> -->
                <v-text-field
                  @click:clear="search = ''; fetch();"
                  v-on:keyup.enter="fetch()"
  
                  filled
                  rounded
                  dense
                  single-line
  
                  hide-details
                  :color="set_color"
                  placeholder="Cari data yang Anda butuhkan . . ."
                  append-icon="mdi-magnify"
                  clearable
  
                  v-model="search"
                  min-height="30"
                  class="ml-3 fs-12 little-placeholder"
                  style="border-radius: 6px; background: #d9e8ff9c !important; max-width: 320px">
                </v-text-field>

                <div class="ml-3" v-if="hak_akses.action.export">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="exports()"
                        :loading="process.export"
                        elevation="0"
                        dark
                        min-height="28"
                        small
                        min-width="28"
                        color="#097640"
                        class="text-capitalize px-0 white--text"
                        style="border-radius: 6px;"
                        v-bind="attrs"
                        v-on="on">
                        <v-icon size="18">mdi-microsoft-excel</v-icon>
                      </v-btn>
                    </template>

                    <span>
                      Export Excel
                    </span>
                  </v-tooltip>
                </div>
  
                <!-- FREEZE COLUMN -->
                <!-- <div class="ml-3">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        elevation="0"
                        outlined
                        dark
                        min-width="36"
                        color="#7B7B7B"
                        class="text-capitalize px-0"
                        style="border-radius: 10px;"
                        v-bind="attrs"
                        v-on="on"
                        @click="dialog.freeze = true">
                        <v-icon size="18">mdi-table-split-cell</v-icon>
                      </v-btn>
                    </template>
  
                    <span>
                      Freeze
                    </span>
                  </v-tooltip>
                </div> -->
  
                <!-- HIDE COLUMN -->
                <!-- <div class="ml-3">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        elevation="0"
                        outlined
                        dark
                        min-width="36"
                        color="#7B7B7B"
                        class="text-capitalize px-0"
                        style="border-radius: 10px;"
                        v-bind="attrs"
                        v-on="on"
                        @click="dialog.hide = true">
                        <v-icon size="18">mdi-eye-off-outline</v-icon>
                      </v-btn>
                    </template>
  
                    <span>
                      Hide
                    </span>
                  </v-tooltip>
                </div> -->
              </v-col>
            </v-row>
  
            <v-card 
              flat
              class="mt-0 mx-5"
              :style="process.load ? '' : list.length === 0 ? '' : ''"
              style="border-radius: 25px; border: 1px solid #E7E7E7;">
              <!-- :height="`calc(100vh - ${pagination.total_data > 0 ? '320px' : '148px'})`" -->
              <div class="view">

                <v-data-table
                  v-model="selected.row"
                  ref="table-grid"
                  class="table-grid"
                  :height="`calc(100vh - ${pagination.total_data > 0 ? '270px' : '248px'})`"
                  :show-select="checkbox"
                  :single-select="true"
                  :loading="process.load"
                  loading-text="Sedang memuat data . . ."
                  loader-height="5"
                  no-results-text="Belum ada data"
                  :options.sync="options"
                  :headers="configHeaders"
                  :items="list"
                  :items-per-page="100"
                  item-key="id"
                  show-expand
                  @toggle-select-all="handleToggleAll($event)"
                  @click:row="rowClick"
                  @dblclick:row="doubleClick"
                  hide-default-footer
                  :expanded.sync="expanded_program"
                  hide-default-header
                  :single-expand="true">
                  <template v-slot:header="{ props: { headers } }">
                    <thead>
                      <tr>
                        <th v-for="h in headers" :key="h" :style="`width: ${h.width === '' ? '' : h.width };background-color: ${set_color} !important; color: #fff;`" :class="`text-${h.align}`">
                          <span>{{h.text}}</span>
                        </th>
                      </tr>
                    </thead>
                  </template>

                  <template
                    v-for="header in configHeaders.filter((header) => header.hasOwnProperty('format'))"
                    v-slot:[`item.${header.value}`]="{ value, index, item }">
                    <div
                      v-bind:key="header.value">
                      <div v-if="header.format !== 'regex' && header.format !== 'image' && header.format !== 'image_potrait' && header.format !== 'image_landscape' && header.format !== 'action' && header.format !== 'bool' && header.format !== 'status' && header.format !== 'link'">
                        {{ rowFormat(header.format, value) }} 
                      </div>

                      <div v-if="header.format === 'link'"
                        class="cursor-pointer">
                        
                      </div>
        
                      <div v-if="header.format === 'regex'">
                        <span
                          class="two-line">
                          {{ rowFormat(header.format, value) }}
                        </span>
                      </div>
        
                      <div v-if="header.format === 'image'"
                        class="ma-4">
                        <v-avatar
                          size="60"
                          tile
                          style="border: 2px dashed #e0e0e0; border-radius: 8px !important;">
                          <v-img 
                            contain
                            width="100%"
                            height="100%"
                            alt="diskominfo" 
                            :src="value !== '' ? value : require('@/assets/image/image_default.png')"
                            class="ma-auto">
                            <template v-slot:placeholder>
                              <v-row
                                class="fill-height"
                                align="center"
                                justify="center">
                                <v-progress-circular 
                                  size="20"
                                  indeterminate 
                                  :color="set_color">
                                </v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                        </v-avatar>
                      </div>

                      <div v-if="header.format === 'image_potrait'"
                        class="ma-4">
                        <v-img 
                          contain
                          width="100"
                          height="125"
                          alt="diskominfo" 
                          :src="value !== '' ? value : require('@/assets/image/image_default.png')"
                          class="ma-auto"
                          style="border: 2px dashed #e0e0e0; border-radius: 8px !important;">
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height"
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                size="20"
                                indeterminate 
                                :color="set_color">
                              </v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </div>

                      <div v-if="header.format === 'image_landscape'"
                        class="ma-4">
                        <v-img 
                          contain
                          width="200"
                          height="125"
                          alt="diskominfo" 
                          :src="value !== '' ? value : require('@/assets/image/image_default.png')"
                          class="ma-auto"
                          style="border: 2px dashed #e0e0e0; border-radius: 8px !important;">
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height"
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                size="20"
                                indeterminate 
                                :color="set_color">
                              </v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </div>

                      <div v-if="header.format === 'action'">
                        <v-tooltip 
                          top
                          v-if="hak_akses.action.add_rencana">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              @click="selected.list = [item]; reset_rencana(); dialog.form_rencana = true; "
                              
                              v-bind="attrs"
                              v-on="on"

                              min-width="28"
                              small
                              rounded
                              color="green"
                              elevation="0"
                              class="white--text text-capitalize mx-1 px-0"
                              style="font-weight: 600; border-radius: 6px;">
                              <v-icon small>mdi-plus-circle</v-icon>
                            </v-btn>
                          </template>

                          <span>Rencana</span>
                        </v-tooltip>
                        <v-tooltip 
                          top
                          v-if="hak_akses.action.update">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              @click="reset(index); dialog.form = true;"
                              
                              v-bind="attrs"
                              v-on="on"

                              min-width="28"
                              small
                              rounded
                              color="blue"
                              elevation="0"
                              class="white--text text-capitalize mx-1 px-0"
                              style="font-weight: 600; border-radius: 6px;">
                              <v-icon small>mdi-square-edit-outline</v-icon>
                            </v-btn>
                          </template>

                          <span>Ubah</span>
                        </v-tooltip>
                        <v-tooltip 
                          top
                          v-if="hak_akses.action.delete">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              @click="toDelete(item.id)"

                              v-bind="attrs"
                              v-on="on"

                              min-width="28"
                              small
                              rounded
                              color="red"
                              elevation="0"
                              class="white--text text-capitalize mx-1 px-0"
                              style="font-weight: 600; border-radius: 6px;">
                              <v-icon small>mdi-trash-can-outline</v-icon>
                            </v-btn>
                          </template>
                          
                          <span>Hapus</span>
                        </v-tooltip>
                      </div>

                      <div v-if="header.format === 'bool'"
                        class="d-flex align-center justify-center">
                        
                      </div>

                      <div v-if="header.format === 'status'"
                        class="d-flex justify-center">
                        
                      </div>
                    </div>
                  </template>


                  <template v-slot:expanded-item="{ headers, item }">
                    <td 
                      :colspan="headers.length - 1" 
                      class="pa-0">
                      <!-- <v-card-text
                        v-if="process.detail" 
                        class="pb-0 my-4" 
                        style="height: 150px; display: flex; align-items: center; justify-content: center;">
                        <div class="text-center">
                          <div class="mb-4 fs-14">
                            Mohon Tunggu . . .
                          </div>
        
                          <v-progress-linear
                            :color="set_color"
                            indeterminate
                            rounded
                            height="5">
                          </v-progress-linear>
                        </div>
                      </v-card-text> -->
        
                      <!-- <v-card-text
                        v-if="!process.detail && list.length === 0"
                        class="pb-0 my-4" style="height: 150px; display: flex; align-items: center; justify-content: center;">
                        <div class="text-center">
                          <v-img 
                            class="mx-auto"
                            contain
                            alt="vuetify"
                            :width="60"
                            :height="60"
                            :src="require('@/assets/image/empty.png')">
                          </v-img>
                          <div class="mt-3 fs-12">
                            Belum Ada Data
                          </div>
                        </div>
                      </v-card-text> -->
                      <div>
                        <div class="pa-4 pb-1">
                          <div class="fs-12 font_weight_600 mb-1 d-flex" style="width: 100%;">
                            Rencana
                          </div>
                        </div>
                        <div v-for="(items, index) in item.category_rencana_array" :key="index" class="mb-2">
                          <div class="px-4">
                            <div class="fs-12 mb-1 d-flex" style="width: 100%;">
                              <div class="pr-1">
                                {{ index+1 }}.
                              </div>
                              <div style="text-transform: capitalize;" class="pr-1">
                                {{ items.title }}
                              </div>

                              <div class="d-flex" v-if="index !== 2">
                                ( 
                                <v-tooltip 
                                  top>
                                  <template v-slot:activator="{ on, attrs }">
                                    <!-- <v-btn
                                      @click="selected.rencana = [items]; toDetail(item.id, items.title); selected.list = [item];"
                                      
                                      v-bind="attrs"
                                      v-on="on"

                                      min-width="20"
                                      x-small
                                      rounded
                                      color="green"
                                      elevation="0"
                                      class="white--text text-capitalize mr-1 px-0"
                                      style="font-weight: 600; border-radius: 5px;">
                                      <v-icon x-small>mdi-plus-circle</v-icon>
                                    </v-btn>
                                  </template> -->
                                    <div class="fs-12 green--text" v-bind="attrs" v-on="on" @click="selected.rencana = [items]; toDetail(item.id, items.id); selected.list = [item];" style="cursor: pointer">
                                      Tambah
                                    </div>
                                  </template>

                                  <span>Plafon</span>
                                </v-tooltip>
                                <!-- <div v-if="items.can_delete_bool === true" class="px-1">
                                  ,
                                </div> -->
                                <v-tooltip 
                                  top v-if="items.can_delete_bool === true && hak_akses.action.add_rencana">
                                  <template v-slot:activator="{ on, attrs }">
                                    <!-- <v-btn
                                      @click="selected.list = [item]; reset_rencana(items); dialog.form_rencana = true;"
                                      
                                      v-bind="attrs"
                                      v-on="on"

                                      min-width="20"
                                      x-small
                                      rounded
                                      color="blue"
                                      elevation="0"
                                      class="white--text text-capitalize mr-1 px-0"
                                      style="font-weight: 600; border-radius: 5px;">
                                      <v-icon x-small>mdi-square-edit-outline</v-icon>
                                    </v-btn> -->
                                    <div class="fs-12 blue--text" v-bind="attrs" v-on="on" @click="selected.list = [item]; reset_rencana(items); dialog.form_rencana = true;" style="cursor: pointer">
                                      , Ubah
                                    </div>
                                  </template>

                                  <span>Ubah</span>
                                </v-tooltip>
                                <!-- <div v-if="items.can_delete_bool === true" class="px-1">
                                  ,
                                </div> -->
                                <v-tooltip 
                                  top v-if="items.can_delete_bool === true && hak_akses.action.delete_rencana">
                                  <template v-slot:activator="{ on, attrs }">
                                    <!-- <v-btn
                                      @click="selected.list = [item]; toDeleteRencana(items.id)"

                                      v-bind="attrs"
                                      v-on="on"

                                      min-width="20"
                                      x-small
                                      rounded
                                      color="red"
                                      elevation="0"
                                      class="white--text text-capitalize mr-1 px-0"
                                      style="font-weight: 600; border-radius: 5px;">
                                      <v-icon x-small>mdi-trash-can-outline</v-icon>
                                    </v-btn> -->
                                    <div class="fs-12 red--text" v-bind="attrs" v-on="on" @click="selected.list = [item]; toDeleteRencana(items.id)" style="cursor: pointer">
                                      , Hapus
                                    </div>
                                  </template>
                                  
                                  <span>Hapus</span>
                                </v-tooltip>
                                )
                              </div>
                              <div class="ml-auto" :class="(items.balance *1) < 0 ? 'red--text' : ''">
                                <span v-if="(items.balance *1) < 0">
                                  ( 
                                </span>
                                {{ items.balance | price }}
                                <span v-if="(items.balance *1) < 0">
                                  )
                                </span>
                              </div>
                            </div>
                            <!-- <div v-for="(i, l) in items.list_array" :key="l" class="py-1">
                              <div class="d-flex align-center fs-12" style="width: 100%;">
                                <div>
                                  {{ l+1 }}.
                                </div>
                                <div class="pl-1" style="text-transform: capitalize;">
                                  <span v-html="i.title"></span>
                                </div>
                                <div class="ml-auto" style="">
                                  {{ i.balance | price }}
                                </div>
                              </div>
                            </div> -->
                          </div>
                          <!-- <v-divider v-if="index < (list.length - 1)"></v-divider> -->
                        </div>
                      </div>
                      <v-divider class="mt-4"></v-divider>
                      <div class="pb-2">
                        <div class="pa-4 pb-1">
                          <div class="fs-12 font_weight_600 mb-1 d-flex" style="width: 100%;">
                            Realisasi
                          </div>
                        </div>
                        <div v-for="(items_realisasi, index_realisasi) in item.category_array" :key="index_realisasi" class="mb-2">
                          <div class="px-4">
                            <div class="fs-12 mb-1 d-flex" style="width: 100%;">
                              <div>
                                {{ index_realisasi+1 }}.
                              </div>

                              <div style="text-transform: capitalize;" class="pl-1">
                                {{ items_realisasi.title }}
                              </div>
                              <v-tooltip v-if="canShowRealisasiDetail(items_realisasi.title)" top>
                                <template v-slot:activator="{ on, attrs }">
                                  <div
                                    class="fs-12 green--text ml-2"
                                    v-bind="attrs"
                                    v-on="on"
                                    @click="toRealisasiDetail(item, items_realisasi)"
                                    style="cursor: pointer; white-space: nowrap;">
                                    ( Detail )
                                  </div>
                                </template>
                                <span>Detail</span>
                              </v-tooltip>
                              <div class="ml-auto" :class="(items_realisasi.balance *1) < 0 ? 'red--text' : ''">
                                <span v-if="(items_realisasi.balance *1) < 0">
                                  ( 
                                </span>
                                {{ items_realisasi.balance | price }}
                                <span v-if="(items_realisasi.balance *1) < 0">
                                  )
                                </span>
                              </div>
                            </div>
                            <!-- <div v-for="(i, l) in items.list_array" :key="l" class="py-1">
                              <div class="d-flex align-center fs-12" style="width: 100%;">
                                <div>
                                  {{ l+1 }}.
                                </div>
                                <div class="pl-1" style="text-transform: capitalize;">
                                  <span v-html="i.title"></span>
                                </div>
                                <div class="ml-auto" style="">
                                  {{ i.balance | price }}
                                </div>
                              </div>
                            </div> -->
                          </div>
                          <!-- <v-divider v-if="index < (list.length - 1)"></v-divider> -->
                        </div>
                      </div>
                    </td>
                    <td></td>
                  </template>

                  <template v-slot:[`item.index`]="{ index }">
                    {{ lastIndex + index }}
                  </template>

                  <v-progress-linear 
                    v-show="process.load" 
                    slot="progress" 
                    color="white" 
                    indeterminate>
                  </v-progress-linear>
                </v-data-table>
  
                <pagination v-if="!process.load && pagination.total_data > 0"
                  @changePage="fetch($event)" 
                  @reloadPage="fetch($event)" 
                  :model="pagination" :display="paginationList"/>
  
              </div>
  
  
              <!-- <pagination v-if="pagination.total_data > 0"
                @changePage="fetch($event)" 
                @reloadPage="fetch($event)" 
                :model="pagination"/> -->
            </v-card>
          </v-card>

        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import axios from "axios";
  import moment from "moment"
  import "moment/locale/id"
  import { downloadProjectRealisasiExcel } from '@/utils/projectRealisasiExport'
  export default {
    data () {
      return {
        checkbox: false,

        dialog: {
          fullscreen: false,
          snackbar: false,
          freeze: false,
          hide: false,

          filter: false,

          form: false,
          delete: false,
          plafon: false,
          form_plafon: false,
          form_rencana: false,
          delete_rencana: false,
          ledger: false
        },
        user_data: [],
        search: '',
        search_plafon: '',

        filter: {
          year: new Date().getFullYear()
        },
        sortBy: 'id',
        sortDesc: '-',

        selected: {
          freeze: [],
          delete: [],
          row: [],
          list: [],
          rencana: [],
          realisasi: [],
          ledger: []
        },

        type: [
          { title: 'Kategori', id: 'Kategori' },
          { title: 'Kantor', id: 'kantor'}
        ],

        form: {
          id: '',
          client: '',
          leader: '',
          name: '',
          use: ''
        },
        form_plafon: {
          id: '',
          project_id: '',
          title: '',
          balance: ''
        },
        form_rencana: {
          id: '',
          project_id: '',
          title: ''
        },
        detail: [],
        list_plafon: [],
        list_ledger: [],
        list_jurnal: [],
        ledger_view: 'list',
        ledger_filter: {
          project_id: '',
          category_id: '',
          ledger_number_lse: ''
        },
        ledger_pagination: {},
        ledger_paginationList: {
          page: 1,
          row: 20
        },
        expanded_program: [],

        options: {},
        headers: [],
        list: [],
        pagination: {},
        paginationList: {
            page: 1,
            row: 20
          },

        lastIndex: 0,
        limit: 20,

        process: {
          load: false,
          detail: false,
          ledger: false,
          jurnal: false,

          delete: false,
          export: false,
          export_ledger: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      pagination: () => import(/* webpackPrefetch: true */ '@/components/pagination_other.vue'),
      ProjectRealisasiTable: () => import(/* webpackPrefetch: true */ '@/components/project/ProjectRealisasiTable.vue'),
      ProjectJurnalTable: () => import(/* webpackPrefetch: true */ '@/components/project/ProjectJurnalTable.vue'),
    },
    watch: {
      // 'options': {
      //   handler () {
      //     let pagination = { row: this.limit, page: 1 }
          
      //     this.fetch(pagination)
      //   },
      //   deep: true
      // }

      'expanded_program'(val) {
        if (val.length > 0) {
          // this.fetchDetail(val[0].id)
        }
      }
    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      user () {
        return this.$store.state.user
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      hak_akses () {
        let menu = {}
        // console.log(this.$store.state.menu)
        this.$store.state.menu.map(item => {
          if (item.id === 7) {
            menu = item
          }
        })
        return menu
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      },

      ledgerDialogClass () {
        return this.ledger_view === 'jurnal'
          ? 'dialog-realisasi dialog-realisasi--jurnal'
          : 'dialog-realisasi'
      },

      configHeaders () {
        return this.headers.filter(header => !header.hide)  
      },

      years () {
        let max = new Date().getFullYear()+2, min = max - 2, years = []

        for (let i = max; i >= min; i--) {
          years.push({
            text: i,
            value: i
          })
        }

        return years
      }
    },
    mounted () {
      this.fetchUser()
      this.fetch()
    },
    methods: {
      toSort(name) {
        this.sortBy = name
        this.sortDesc = ''
        this.fetch()
      },
      toDesc() {
        this.sortDesc === '-' ? this.sortDesc = '' : this.sortDesc = '-'
        this.fetch()
      },
      async fetchUser () {
        let params = {
          limit: 100000000000,
          'id[nin]': '1'
        }

        await get(`admin/data`, { params })
        .then(response => {
          let res = response.data

          if (res.status === 200) {
            this.user_data = res.results.data
          }
        })
      },
      rowFormat (format, value) {
        let data = value

        if (format === 'number') {
          if (isNaN(value)) return 'Not a Number'
          let price = ''

          const reverseNumber = value
            .toString()
            .split('')
            .reverse()
            .join('')
          const arrReverseNumber = [...Array(reverseNumber.length).keys()]

          arrReverseNumber.map(index => {
            if (index % 3 === 0) price += reverseNumber.substr(index, 3) + '.'
          })

          return `Rp ${
            price.split('', price.length - 1)
            .reverse()
            .join('')
          }`
        } else if (format === 'array') {
          let arr = []

          for (let i = 0; i < value.length; i++) {
            arr.push(value[i].label)
          }

          data = arr.join(', ')
        } else if (format === 'date') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY') : '-'
        } else if (format === 'time') {
          data = value.length > 0 ? moment(value).format('HH:mm') : '-'
        } else if (format === 'datetime') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY HH:mm') : '-'
        } else if (format === 'object') {
          data = value.createdby.name
        } else if (format === 'regex') {
          let regex = /(<([^>]+)>)/ig

          data = value.replace(regex, '')
        } else if (format === 'underscore') {
          let regex = /_/g

          data = value.replace(regex, ' ')
        } else if (format === 'on_off') {
          data = value ? 'Online' : 'Offline'
        } else if (format === 'g_m') {
          data = value ? 'Mandiri' : 'Group'
        } else if (format === 'v_a') {
          data = value ? 'Sudah Verifikasi' : 'Belum Verifikasi'
        } else if (format === 'y_n') {
          data = parseInt(value) ? 'Ya' : 'Tidak'
        } else if (format === 'percent') {
          data = parseInt(value) + '%'
        } else if (format === 'action') {
          data = value
        } else if (format === 'bool') {
          data = value
        } else if (format === 'status') {
          data = value
        } else if (format === 'link') {
          data = value
        }  else {
          data = value ? 'Aktif' : 'Tidak Aktif'
        }

        return data
      },
      rowClick (item, row) {
        // row.select(!row.isSelected ? true : false)

        // // this.expanded_program = []

        // // this.expanded_kegiatan = []

        // // this.selected.row_kegiatan = []

        // // this.selected.row_sub_kegiatan = []

        // if (row.isExpanded) {
        //   // const indexExpanded = this.expanded_program.findIndex(i => i === item)
        //   // this.expanded_program.splice(indexExpanded, 1)
        // } else {
        //   // this.expanded_program.push(item)
        //   }
        // this.fetchDetail(item.id)

        
      },
      async fetchDetail (id, category_id) {
        this.process.detail = true
        this.detail = []

        let params = {
          project_id: id,
          // search: this.search_plafon
          category_id: category_id
        }

        await get(`project/report/data`, { params })
        .then(response => {
          let res = response.data

          this.process.detail = false

          if (res.status === 200) {
            let objData = res.results.data
            // const tempArray = res.results.data.map((obj, l)=>{
            //   obj.detail_array.map((i, index) => {
            //     objData[l].detail_array[index].title = (objData[l].detail_array[index].title).toLowerCase()
            //   })
            //   return objData[l]
            // });

            // this.detail = tempArray
            this.list_plafon = res.results.data
            // res.results.data.filter(i => i.type === 'Plafon Anggaran').map(i => {
            //   this.list_plafon = i.detail_array
            // })
          }
        })
      },
      doubleClick (event, {item}) {
        // NO ACTION
        console.log(item)
      },
      handleToggleAll (event) {
        if (!event.value) this.selected.row = []
      },

      async fetch (pagination = { row: 20, page: 1 }) {
        this.process.load = true

        this.limit = pagination.row
        this.paginationList = pagination

        let params = {
          category_id: this.selected.category_id,
          limit: pagination.row,
          page: pagination.page,
          sort: `${this.sortDesc}${this.sortBy}`,
          // sort: this.options.sortBy.length < 1 ? 'id' : this.options.sortDesc[0] ? `-${this.options.sortBy[0]}` : this.options.sortBy[0],
          // order_by: this.options.sortDesc[0] ? 'ASC' : 'DESC',
          search: this.search,
          // unit_id: this.$store.state.user.unit_id === '0' || this.$store.state.user.unit_id === 0 ? '' : this.$store.state.user.unit_id
        }

        this.selected.row = []

        // admin/services/data
        
        await get(`project/data`, { params })
        .then(response => {
          let res = response.data
          
          this.process.load = false
          
          this.list = []
          this.pagination = {}
          
          if (res.status === 200) {
            this.headers = [
              {
                text: 'Aksi',
                value: 'action',
                // width: '110px',
                align: 'center',
                format: 'action',
                freeze: true,
                hide: false
              },
              {
                text: 'Nama',
                // width: '700px',
                value: 'name',
                freeze: false,
                hide: false
              },
              {
                text: 'Client',
                // width: '400px',
                value: 'client',
                freeze: false,
                hide: false
              },
              {
                text: 'Leader',
                // width: '400px',
                value: 'leader',
                freeze: false,
                hide: false
              },
              {
                text: 'Use',
                // width: '400px',
                value: 'use',
                freeze: false,
                hide: false
              },

              {
                text: '',
                width: '100%',
                value: 'empty',
                freeze: false,
                hide: false
              },

              // {
              //   text: 'Alamat',
              //   width: '400px',
              //   value: 'address',
              //   freeze: false,
              //   hide: false
              // },
              // {
              //   text: 'Type',
              //   width: '150px',
              //   value: 'type',
              //   freeze: false,
              //   hide: false
              // },
              // {
              //   text: '',
              //   width: '300px',
              //   value: 'id',
              //   freeze: true,
              //   hide: false,
              //   align: 'end',
              //   format: 'action'
              // },
            
            ]
    
            this.list = res.results.data
            this.pagination = res.results.pagination

            // this.list.map(obj => {
            //   obj.is_active = obj.is_active === 'Aktif' ? true : false
            // })

            this.lastIndex = (pagination.page - 1) * pagination.row 
            this.lastIndex += 1


            this.addFreezes()

            this.$vuetify.goTo(this.$refs['table-grid'], { container: this.$refs['table-grid'].$el.querySelector('div.v-data-table__wrapper-project') })

            if (this.headers.length < 7 && this.list.length > 0) this.getTableToResize()
          }
        })
      },


      addFreezes () {
        this.removeFreezes()

        this.selected.freeze = []

        for (let i = 0; i < this.configHeaders.length; i++) {
          if (this.configHeaders[i].freeze) {
            // ADD TO SELECTOR
            this.selected.freeze.push({
              child: i + (this.checkbox ? 2 : 1),
              width: this.configHeaders[i].width.split('px')[0]
            })

            // LOOP STYLESHEET
            for (let f = 0; f < this.selected.freeze.length; f++) {
              let style = document.createElement('style'),
                  width = 0

              if (this.checkbox) {
                width = f < 1 ? '65' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) + 65 : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width) + 65
              } else {
                width = f < 1 ? '0' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width)
              }

              // ADD STYLESHET TO FREEZE
              style.innerHTML = `
                .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 5;
                  background: #FFFFFF;
                }

                .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 1;
                }
              `

              // ADD TO APPENDCHILD
              document.head.appendChild(style)
            }
          }
        }
      },
      removeFreezes () {
        // LOOP STYLESHEET
        for (let f = 0; f < this.selected.freeze.length; f++) {
          let style = document.createElement('style')
          
          // RESET STYLESHEET TO AUTO
          style.innerHTML = `
            .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
              background: #FFFFFF;
            }

            .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
            }
          `

          // ADD TO APPENDCHILD
          document.head.appendChild(style)
        }
      },
      addHides () {
        if (this.headers.length < 6) this.getTableToResize()
      },
      getTableToResize () {
        let tables = document.getElementsByTagName('table')

        for (let i = 0; i < tables.length; i++) {
          this.resizableGrid(tables[i])
        }
      },
      resizableGrid (table) {
        let row = table.getElementsByTagName('tr')[0],
            cols = row ? row.children : undefined
        
        if (!cols) return
        
        table.style.overflow = 'hidden'
        
        let tableHeight = table.offsetHeight
        
        for (let i = 0; i < cols.length; i++) {
          let div = createDiv(tableHeight)
          cols[i].appendChild(div)
          cols[i].style.position = 'relative'

          setListeners(div)
        }

        function setListeners (div) {
          let pageX, curCol, nxtCol, curColWidth, nxtColWidth

          div.addEventListener('mousedown', e => {
            curCol = e.target.parentElement
            nxtCol = curCol.nextElementSibling
            pageX = e.pageX
            
            let padding = paddingDiff(curCol)
            
            curColWidth = curCol.offsetWidth - padding

            if (nxtCol) nxtColWidth = nxtCol.offsetWidth - padding
          })

          div.addEventListener ('mouseover', e => {
            e.target.style.borderRight = '2px solid #e0e0e0'
          })

          div.addEventListener ('mouseout', e => {
            e.target.style.borderRight = ''
          })

          document.addEventListener ('mousemove', e => {
            if (curCol) {
              let diffX = e.pageX - pageX
          
              if (nxtCol) nxtCol.style.width = (nxtColWidth - (diffX))+'px'

              curCol.style.width = (curColWidth + diffX)+'px'
            }
          })

          document.addEventListener ('mouseup', () => { 
            curCol = undefined
            nxtCol = undefined
            pageX = undefined
            nxtColWidth = undefined
            curColWidth = undefined
          })
        }

        function createDiv (height) {
          let div = document.createElement('div')

          div.style.top = 0
          div.style.right = 0
          div.style.width = '1px'
          div.style.position = 'absolute'
          div.style.cursor = 'col-resize'
          div.style.userSelect = 'none'
          div.style.height = height + 'px'
          div.style.background = '#e0e0e0'

          return div
        }

        function paddingDiff (col) {
          if (getStyleVal(col,'box-sizing') == 'border-box') {
            return 0
          }
          
          let padLeft = getStyleVal(col,'padding-left')
          let padRight = getStyleVal(col,'padding-right')

          return (parseInt(padLeft) + parseInt(padRight))
        }

        function getStyleVal (elm,css) {
          return (window.getComputedStyle(elm, null).getPropertyValue(css))
        }
      },

      toDetail (index, category_id) {
        this.dialog.plafon = true

        this.fetchDetail(index, category_id)
      },
      canShowRealisasiDetail (title) {
        const t = (title || '').toLowerCase()

        return !t.includes('saldo')
      },
      getLedgerNumberPrefix (title) {
        const t = (title || '').toLowerCase()

        if (t.includes('pendapatan') || t.includes('piutang')) return 'TRP'
        if (t.includes('belanja')) return 'TRI'

        return ''
      },
      toRealisasiDetail (project, realisasi) {
        if (!this.canShowRealisasiDetail(realisasi.title)) return

        this.selected.list = [project]
        this.selected.realisasi = [realisasi]
        this.ledger_view = 'list'
        this.ledger_filter = {
          project_id: project.id,
          category_id: realisasi.id,
          ledger_number_lse: this.getLedgerNumberPrefix(realisasi.title)
        }
        this.dialog.ledger = true
        this.fetchLedger({ row: 20, page: 1 })
      },
      backToLedgerList () {
        this.ledger_view = 'list'
        this.list_jurnal = []
      },
      closeLedgerDialog () {
        this.dialog.ledger = false
        this.dialog.fullscreen = false
        this.ledger_view = 'list'
        this.list_jurnal = []
      },
      async fetchLedger (pagination = { row: 20, page: 1 }) {
        this.ledger_paginationList = pagination
        this.process.ledger = true
        this.list_ledger = []

        let params = {
          limit: pagination.row,
          page: pagination.page,
          project_id: this.ledger_filter.project_id,
          category_id: this.ledger_filter.category_id
        }

        if (this.ledger_filter.ledger_number_lse) {
          params['ledger_number[lse]'] = this.ledger_filter.ledger_number_lse
        }

        await get('project/report/data', { params })
        .then(response => {
          let res = response.data

          this.process.ledger = false

          if (res.status === 200) {
            this.list_ledger = res.results.data
            this.ledger_pagination = res.results.pagination !== undefined ? res.results.pagination : {}
          } else {
            this.list_ledger = []
            this.ledger_pagination = {}
          }
        })
      },
      async exportLedgerExcel () {
        if (this.ledger_view !== 'list') return

        this.message.error = ''
        this.process.export_ledger = true

        let params = {
          pagination_bool: false,
          project_id: this.ledger_filter.project_id,
          category_id: this.ledger_filter.category_id
        }

        if (this.ledger_filter.ledger_number_lse) {
          params['ledger_number[lse]'] = this.ledger_filter.ledger_number_lse
        }

        try {
          const response = await get('project/report/data', { params })
          const res = response.data

          if (res.status !== 200) {
            this.message.error = res.message || 'Gagal mengambil data realisasi'
            return
          }

          const items = Array.isArray(res.results.data) ? res.results.data : []

          if (items.length === 0) {
            this.message.error = 'Tidak ada data untuk diekspor'
            return
          }

          downloadProjectRealisasiExcel({
            items,
            projectName: this.selected.list.length > 0 ? this.selected.list[0].name : '',
            categoryTitle: this.selected.realisasi.length > 0 ? this.selected.realisasi[0].title : '',
            balance: this.selected.realisasi.length > 0 ? this.selected.realisasi[0].balance : 0
          })

          this.dialog.snackbar = true
          this.message.success = 'Berhasil mengeksport Excel'
        } catch (error) {
          this.message.error = 'Gagal mengekspor Excel'
        } finally {
          this.process.export_ledger = false
        }
      },
      toJurnalDetail (item) {
        this.selected.ledger = [item]
        this.ledger_view = 'jurnal'

        this.fetchJurnal(item)
      },
      async fetchJurnal (item) {
        this.process.jurnal = true
        this.list_jurnal = []

        let params = {
          number: item.ledger_number
        }

        await get('jurnal/data', { params })
        .then(response => {
          let res = response.data

          this.process.jurnal = false

          if (res.status === 200) {
            this.list_jurnal = res.results.data
          }
        })
      },

      reset_plafon (index) {
        if (this.$refs.form_plafon) this.$refs.form_plafon.reset()
        
        this.form_plafon = {
          id: index !== undefined ? this.list_plafon[index].id : '',
          project_id: this.selected.list[0].id,
          // title: index !== undefined ? this.list_plafon[index].title : '',
          value: index !== undefined ? this.list_plafon[index].value : '',
          category_id: this.selected.rencana[0].id,
          note: index !== undefined ? this.list_plafon[index].note : ''
        }

        this.process.form = false

        this.message.error = ''
      }, 

      reset_rencana (index) {
        console.log(index!==undefined)
        if (this.$refs.form_rencana) this.$refs.form_rencana.reset()
        
        this.form_rencana = {
          id: index !== undefined ? index.id : '',
          project_id: this.selected.list[0].id,
          title: index !== undefined ? index.title : '',
        }

        this.process.form = false

        this.message.error = ''
      },

      reset (index) {
        if (this.$refs.form) this.$refs.form.reset()
        
        this.form = {
          id: index !== undefined ? this.list[index].id : '',
          name: index !== undefined ? this.list[index].name : '',
          client: index !== undefined ? this.list[index].client : '',
          leader: index !== undefined ? this.list[index].leader : '',
          use: index !== undefined ? this.list[index].use : ''
        }

        this.process.form = false

        this.message.error = ''
      },

      async save_rencana () {
        this.message.error = ''

        const isValid = await this.$refs.form_rencana.validate()

        if (isValid) {
          this.process.form = true

          let url = this.form_rencana.id === '' ? 'project/category/add' : 'project/category/update'

          // SAVE TO REST API
          await post(url, {
            data: {
              id: this.form_rencana.id,
              project_id: this.selected.list[0].id,
              title: this.form_rencana.title
            }
          })
          .then(response => {
            let res = response.data
            
            this.process.form = false

            if (res.status === 200) {
              this.dialog.form_rencana = false

              this.dialog.snackbar = true
              this.message.success = res.message

              this.dialog.fullscreen = false

              // this.fetchDetail(this.form_plafon.project_id)
              this.fetch(this.paginationList)
              this.reset_rencana()

            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form_plafon.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form_plafon.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },

      async save_plafon () {
        this.message.error = ''

        const isValid = await this.$refs.form_plafon.validate()

        if (isValid) {
          this.process.form = true

          let url = this.form_plafon.id === '' ? 'project/report/add' : 'project/report/update'

          // SAVE TO REST API
          await post(url, {
            data: this.form_plafon
          })
          .then(response => {
            let res = response.data
            
            this.process.form = false

            if (res.status === 200) {
              this.dialog.form_plafon = false

              this.dialog.snackbar = true
              this.message.success = res.message

              this.dialog.fullscreen = false

              this.fetchDetail(this.form_plafon.project_id, this.selected.rencana[0].id)
              this.reset_plafon()
              this.fetch(this.paginationList)

            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form_plafon.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form_plafon.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()

        if (isValid) {
          this.process.form = true

          let url = this.form.id === '' ? 'project/add' : 'project/update'

          // SAVE TO REST API
          await post(url, {
            data: this.form
          })
          .then(response => {
            let res = response.data
            
            this.process.form = false

            if (res.status === 200) {
              this.dialog.form = false

              this.dialog.snackbar = true
              this.message.success = res.message

              this.dialog.fullscreen = false

              if (this.form.id === '') {
                this.fetch()
              } else {
                this.fetch(this.paginationList)
              }
              this.reset()

            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },

      toDeleteRencana (id) {
        this.selected.delete = [id]
        // console.log(this.selected.delete)

        this.dialog.delete_rencana = true
      },
      async deletesRencana () {
        this.message.error = ''

        this.process.delete = true

        let url = 'project/category/delete'

        await post(url, {
          data: {
            id: this.selected.delete[0],
            project_id: this.selected.list[0].id
          }
        }).then(response => {
          let res = response.data

          this.process.delete = false

          if (res.status === 200) {

            this.dialog.delete_rencana = false

            this.selected.row = []
            this.selected.delete = []
            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetch(this.paginationList)
            // if (this.dialog.plafon === true) this.fetchDetail(this.selected.list[0].id)
          } else {
            this.message.error = res.message
          }
        })
      },

      toDelete (id) {
        this.selected.delete = [id]
        // console.log(this.selected.delete)

        this.dialog.delete = true
      },
      async deletes () {
        this.message.error = ''

        this.process.delete = true

        let url = this.dialog.plafon === true ? 'project/report/delete' : 'project/delete'

        await post(url, {
          data: this.dialog.plafon === true ? {
            id: this.selected.delete[0],
            project_id: this.selected.list[0].id,
            category_id: this.selected.rencana[0].id
          } : {
            id: this.selected.delete[0]
          }
        }).then(response => {
          let res = response.data

          this.process.delete = false

          if (res.status === 200) {

            this.dialog.delete = false

            this.selected.row = []
            this.selected.delete = []
            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetch(this.paginationList)
            if (this.dialog.plafon === true) this.fetchDetail(this.selected.list[0].id, this.selected.rencana[0].id)
          } else {
            this.message.error = res.message
          }
        })
      },

      async exports () {
        this.message.error = ''

        this.process.export = true

        let params = {
          search: this.search
        }

        await axios({
          url: `${process.env.VUE_APP_API_URL}/project/export_excel`,
          method: 'GET',
          responseType: 'blob', // important,
          params: params,
          headers: {
            Authorization: process.env.VUE_APP_XAUTH,
            token: TokenService.getToken()
          }
        }).then((response) => {
          let res = response

          this.process.export = false
          console.log(res.headers)
          let disposition = res.headers['content-disposition']
          console.log(disposition)
          var fileName = res.headers['content-disposition'].split('filename=')[1]
          // let filename = ''

          // if (disposition && disposition.indexOf('inline') !== -1) {
          //   var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          //   var matches = filenameRegex.exec(disposition);
          //   if (matches != null && matches[1]) { 
          //     filename = matches[1].replace(/['"]/g, '');
          //   }
          // }
          console.log(fileName)

          if (res.status === 200) {
            this.dialog.snackbar = true
            this.message.success = 'Berhasil mengeksport Excel'

            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url

            link.setAttribute('download', fileName)
            document.body.appendChild(link)

            link.click()
          } else {
            this.message.error = res.message
          }
        })
      }

    }
  }
</script>

<style>
  /* ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
    background-color: #F5F5F5;
  }
  ::-webkit-scrollbar-track{
    background-color: #F5F5F5;
    border-radius: 10px;
  } */
  ::-webkit-scrollbar-thumb{
    border-radius: 10px;
    background-color: #718EBF;
  }
  table, th, td {
  /* border: 1px solid #ededed;
  border-collapse: collapse; */
  /* border: thin ridge black; */
  border-spacing: 4px;
  border-collapse: collapse;
}

.view {
  margin: auto;
  /* width: 100%; */
}

.wrapper-project { 
  overflow-y: auto; 
  height: calc(100vh - 400px); 
} 

.wrapper-project-none { 
  /* overflow-y: auto; 
  height: calc(100vh - 270px);  */
} 

.wrapper-project th { 
  position: sticky; 
  top: 0; 
  /* background-color: #080679 !important; */
} 
.sticky-col {
  position: -webkit-sticky;
  position: sticky;
  /* background-color: #080679 !important; */
}

.one-col {
  width: 60px;
  min-width: 60px;
  max-width: 60px;
  left: 0px;
}

.second-col {
  width: 150px;
  min-width: 150px;
  max-width: 150px;
  left: 150px;
}

.three-col {
  width: 150px;
  min-width: 150px;
  max-width: 150px;
  left: 300px;
}

.four-col {
  width: 200px;
  min-width: 200px;
  max-width: 200px;
  left: 450px;
}

.wrapper-buku-besar { 
  overflow-y: auto; 
  height: calc(100vh - 305px); 
} 
.wrapper-buku-besar th { 
  position: sticky; 
  top: 0; 
  background-color: #080679 !important;
} 

.dialog-realisasi {
  max-width: 900px !important;
}

.dialog-realisasi--jurnal {
  max-width: min(1280px, 96vw) !important;
}

.ledger-dialog__header {
  background: #f7f8fa !important;
  border-bottom: 1px solid #e0e3e8;
  padding: 12px 16px !important;
  min-height: 44px;
}

.ledger-dialog__header-text {
  min-width: 0;
  flex: 1;
  font-size: 15px;
  font-weight: 600;
  color: #1f2933;
  line-height: 1.3;
}

.ledger-dialog__header-actions {
  gap: 6px;
  flex-shrink: 0;
}

.ledger-dialog__icon-btn {
  width: 28px !important;
  height: 28px !important;
  min-width: 28px !important;
  background-color: #ffffff !important;
  border: 1px solid #e0e3e8 !important;
  border-radius: 6px !important;
  box-shadow: none !important;
  color: #374151 !important;
}
.ledger-dialog__icon-btn::before {
  opacity: 0 !important;
}
.ledger-dialog__icon-btn:hover {
  background-color: #eef2f7 !important;
  border-color: #c6ccd4 !important;
}
.ledger-dialog__icon-btn .v-icon {
  color: #374151 !important;
}

.ledger-dialog__body {
  background: #ffffff;
}

.ledger-dialog__loading,
.ledger-dialog__empty {
  height: 280px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ledger-dialog__footer {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  padding: 10px 16px;
  background: #f7f8fa;
  border-top: 1px solid #e0e3e8;
}

.ledger-dialog__btn-group {
  gap: 8px;
}

.ledger-dialog__btn {
  min-height: 30px !important;
  height: 30px !important;
  padding: 0 12px !important;
  box-shadow: none !important;
  letter-spacing: normal !important;
  text-transform: none !important;
  font-weight: 600 !important;
  font-size: 12px !important;
  border-radius: 6px !important;
}
.ledger-dialog__btn::before {
  opacity: 0 !important;
}
.ledger-dialog__btn-icon {
  margin-right: 2px;
}

.ledger-dialog__btn--back {
  background-color: #e8f2f8 !important;
  border: 1px solid #9ec5de !important;
  color: #0072b2 !important;
}
.ledger-dialog__btn--back:hover {
  background-color: #d4e8f4 !important;
  border-color: #0072b2 !important;
}
.ledger-dialog__btn--back .v-icon {
  color: #0072b2 !important;
}

.ledger-dialog__btn--close {
  background-color: #ffffff !important;
  border: 1px solid #e0e3e8 !important;
  color: #374151 !important;
}
.ledger-dialog__btn--close:hover {
  background-color: #eef2f7 !important;
  border-color: #c6ccd4 !important;
}

@media (max-width: 1264px) {
  .dialog-realisasi,
  .dialog-realisasi--jurnal {
    max-width: 96vw !important;
  }

  .ledger-dialog__body {
    padding-left: 12px !important;
    padding-right: 12px !important;
  }
}

tr:hover {background-color: #1976d236;}
tr.selected {background-color: #1976d236;}
</style>